import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/images/lieferung.png'
import _imports_1 from './assets/images/DIN_Certco_zertifiziert.png'
import _imports_2 from './assets/images/ekomi_bewertung_70px.png'
import _imports_3 from '../src/assets/icons/phone-solid.svg'
import _imports_4 from '../src/assets/icons/envelope-solid.svg'
import _imports_5 from '@/assets/images/payment/payment-icon-paypal.svg'
import _imports_6 from '@/assets/images/payment/payment-icon-sepa.png'
import _imports_7 from '@/assets/images/payment/payment-icon-visa.svg'
import _imports_8 from '@/assets/images/payment/payment-icon-mastercard.svg'


const _hoisted_1 = { role: "main" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section id=\"seals\"><div class=\"container\"><div class=\"row\"><div class=\"col-12 col-md-4\"><div class=\"row\"><div class=\"col-3\"><img src=\"" + _imports_0 + "\" class=\"img-fluid\"></div><div class=\"col-9 align-self-center\"><p class=\"mb-0\"><b>Schneller &amp; kostenloser Versand</b><br> Garantiert - ohne Mindestbestellwert </p></div></div></div><div class=\"col-12 col-md-4\"><div class=\"row\"><div class=\"col-3\"><img src=\"" + _imports_1 + "\" class=\"img-fluid\"></div><div class=\"col-9 align-self-center\"><p class=\"mb-0\"><b>Beste Qualität - Geprüft und DIN zertifiziert</b><br> in allen Zulassungsstellen anerkannt </p></div></div></div><div class=\"col-12 col-md-4\"><div class=\"row\"><div class=\"col-3\"><img src=\"" + _imports_2 + "\" class=\"img-fluid\"></div><div class=\"col-9 align-self-center\"><p class=\"mb-0\"><b>persönlicher &amp; kompetenter Kundenservice</b><br> überzeugen Sie sich selbst! </p></div></div></div></div></div></section>", 1)
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-lg-4\"><h3>Kundenservice</h3><p> wunschkennzeichen Deuschland GmbH <br> Otto-Shott-Straße 7, D-47906 Kempen </p><div class=\"d-flex flex-column align-items-start\"><a class=\"contact-button\" href=\"tel:021529939909\"><img width=\"21\" class=\"me-2\" src=\"" + _imports_3 + "\"><span>02152 - 993 9909</span></a><a class=\"contact-button\" href=\"mailto:support@wunschkennzeichen.de\"><img class=\"me-2\" width=\"21\" src=\"" + _imports_4 + "\"><span> support@wunschkennzeichen.de </span></a></div></div>", 1)
const _hoisted_7 = { class: "col-12 col-lg-4 mt-4 mt-lg-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Versand", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createTextVNode(" Schneller und Kostenloser Versand per DHL."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.wunschkennzeichen.de/lieferung",
    target: "_blank"
  }, "Mehr Informationen")
], -1)
const _hoisted_10 = { class: "delivery-animation" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-lg-4 mt-4 mt-lg-0\"><h3>Zahlung</h3><p> Mit einem unserer Zahlungsanbieter können Sie Ihre Bestellung schnell und ohne Aufwand bezahlen. </p><div class=\"payment-icons\"><img src=\"" + _imports_5 + "\" alt=\"paypal\"><img src=\"" + _imports_6 + "\" alt=\"sepa\"><img src=\"" + _imports_7 + "\" alt=\"visa\"><img src=\"" + _imports_8 + "\" alt=\"mastercard\"></div></div><div class=\"col-12 mt-4\"><h4>Weitere Informationen</h4><div class=\"additional-links\"><div><a href=\"https://www.wunschkennzeichen.de/agb\" target=\"_blank\">AGB</a></div><div><a href=\"https://support.wunschkennzeichen.de/hc/de/requests/new\" target=\"_blank\">Helpcenter</a></div><div><a href=\"https://www.wunschkennzeichen.de/impressum\" target=\"_blank\">Impressum</a></div><div><a href=\"https://www.wunschkennzeichen.de/lieferung\" target=\"_blank\">Versand</a></div><div><a href=\"https://www.wunschkennzeichen.de/datenschutz\" target=\"_blank\">Datenschutz</a></div><div><a href=\"https://www.wunschkennzeichen.de/schilderpartner-deutschland.html\" target=\"_blank\">Schilderpartner</a></div><div><a href=\"https://www.wunschkennzeichen.de/widerrufsbelehrung\" target=\"_blank\">Widerrufsrecht</a></div></div></div>", 2)

import DeliveryAnimation from '@/assets/animations/animation-delivery.json';
import NavigationBar from '@/components/Layout/NavigationBar.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavigationBar),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _hoisted_2,
    _createElementVNode("footer", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Vue3Lottie, {
                animationData: _unref(DeliveryAnimation),
                height: 120,
                width: 120
              }, null, 8, ["animationData"])
            ])
          ]),
          _hoisted_11
        ])
      ])
    ])
  ], 64))
}
}

})